module.exports = __webpack_public_path__ + "media/assets/images/blog/short_week-d10292a7f1d03a02f995f8efcde96031.png";